import { Skeleton } from '@mui/material'
import { ColDef } from 'ag-grid-community'
import { AgGridReact, AgGridReactProps } from 'ag-grid-react'
import clsx from 'clsx'
import { ClassName } from 'types/props'

import classes from './loading.module.scss'
import tableClasses from './table.module.scss'

const WIDTH_MAP = {
  sm: '40px',
  md: '100px',
  lg: '200px',
  xl: '400px',
  full: '90%'
}
interface LoadingCellProps {
  width: keyof typeof WIDTH_MAP
}
export const LoadingCell = ({ width }: LoadingCellProps) => (
  <div className={classes.loadingCell}>
    <Skeleton height="15px" variant="rectangular" width={WIDTH_MAP[width]} />
  </div>
)

export const SmLoadingCell = () => <LoadingCell width="sm" />
export const MdLoadingCell = () => <LoadingCell width="md" />
export const LgLoadingCell = () => <LoadingCell width="lg" />
export const XlLoadingCell = () => <LoadingCell width="xl" />
export const FullLoadingCell = () => <LoadingCell width="full" />

const LOADING_CELL_MAP = {
  sm: SmLoadingCell,
  md: MdLoadingCell,
  lg: LgLoadingCell,
  xl: XlLoadingCell,
  full: FullLoadingCell
}

export interface ColDefWithLoading extends ColDef {
  loadingCellRenderer?: React.ComponentType<any>
  loadingCellWidth?: keyof typeof WIDTH_MAP
}
interface AgGridReactPropsWithLoadingWidth extends AgGridReactProps {
  columnDefs: ColDefWithLoading[]
}
interface LoadingTableProps extends ClassName {
  agGridProps: Omit<AgGridReactPropsWithLoadingWidth, 'rowData'>
  height?: string
  rowCount?: number
  showGreyHeader?: boolean
}

export const LoadingTable = ({
  agGridProps,
  className,
  height,
  rowCount = 10,
  showGreyHeader
}: LoadingTableProps) => {
  const fakeRows = new Array(rowCount).fill(null)
  const LOADING_COLUMNS = agGridProps.columnDefs.map(
    ({ loadingCellRenderer, loadingCellWidth, ...col }) => {
      const cellRenderer =
        loadingCellRenderer ||
        (loadingCellWidth ? LOADING_CELL_MAP[loadingCellWidth] : FullLoadingCell)

      return {
        ...col,
        cellRenderer
      }
    }
  )

  return (
    <div
      className={clsx(className, tableClasses.tableWrapper, 'ag-theme-alpine', {
        [tableClasses.greyHeader]: showGreyHeader
      })}
      style={height ? { height, maxHeight: height } : {}}
    >
      <AgGridReact {...agGridProps} columnDefs={LOADING_COLUMNS} rowData={fakeRows} />
    </div>
  )
}
